<template lang="pug">
.editor
  .menubar(:editor="editor" v-if="editor")
    button.menubar__button(:class="{ 'is-active': editor.isActive('bold') }" @click="editor.chain().focus().toggleBold().run()")
      .icon
        img(src='../../../assets/tiptap/images/icons/bold.svg')
    button.menubar__button(@click="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }")
      .icon
        img(src='../../../assets/tiptap/images/icons/italic.svg')
    button.menubar__button(@click="editor.chain().focus().toggleStrike().run()" :class="{ 'is-active': editor.isActive('strike') }")
      .icon
        img(src='../../../assets/tiptap/images/icons/strike.svg')
    button.menubar__button(:class="{ 'is-active': editor.isActive('underline') }" @click="editor.chain().focus().toggleUnderline().run()")
      .icon
        img(src='../../../assets/tiptap/images/icons/underline.svg')
    .menubar__button
      input(type='color' @input='editor.chain().focus().setColor($event.target.value).run()' :value='editor.getAttributes("textStyle").color')
    button.menubar__button(@click="editor.chain().focus().setTextAlign('left').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'left' }) }")
      .icon
        img(src='../../../assets/tiptap/images/icons/left.svg')
    button.menubar__button(@click="editor.chain().focus().setTextAlign('center').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'center' }) }")
      .icon
        img(src='../../../assets/tiptap/images/icons/center.svg')
    button.menubar__button(@click="editor.chain().focus().setTextAlign('right').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'right' }) }")
      .icon
        img(src='../../../assets/tiptap/images/icons/right.svg')
    button.menubar__button(@click="editor.chain().focus().setTextAlign('justify').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'justify' }) }")
      .icon
        img(src='../../../assets/tiptap/images/icons/justify.svg')
    button.menubar__button(@click="editor.chain().focus().toggleCode().run()" :class="{ 'is-active': editor.isActive('code') }")
      .icon
        img(src='../../../assets/tiptap/images/icons/code.svg')
    button.menubar__button(:class="{ 'is-active': editor.isActive('paragraph') }" @click="editor.chain().focus().setParagraph().run()")
      .icon
        img(src='../../../assets/tiptap/images/icons/paragraph.svg')
    button.menubar__button(:class="{ 'is-active': editor.isActive('heading', { level: 1 }) }" @click="editor.chain().focus().toggleHeading({ level: 1 }).run()")                         
      p H1
    button.menubar__button(:class="{ 'is-active': editor.isActive('heading', { level: 2 }) }" @click="editor.chain().focus().toggleHeading({ level: 2 }).run()")
      p H2
    button.menubar__button(:class="{ 'is-active': editor.isActive('heading', { level: 3 }) }" @click="editor.chain().focus().toggleHeading({ level: 3 }).run()")
      p H3
    button.menubar__button(@click="editor.chain().focus().toggleBulletList().run()" :class="{ 'is-active': editor.isActive('bulletList') }")
      .icon
        img(src='../../../assets/tiptap/images/icons/ul.svg')
    button.menubar__button(@click="editor.chain().focus().toggleOrderedList().run()" :class="{ 'is-active': editor.isActive('orderedList') }")
      .icon
        img(src='../../../assets/tiptap/images/icons/ol.svg')
    button.menubar__button(@click="editor.chain().focus().toggleBlockquote().run()" :class="{ 'is-active': editor.isActive('blockquote') }")
      .icon
        img(src='../../../assets/tiptap/images/icons/quote.svg')
    //- button.menubar__button(@click="editor.chain().focus().toggleCodeBlock().run()" :class="{ 'is-active': editor.isActive('codeBlock') }")
    //-   .icon
    //-     img(src='../../../assets/tiptap/images/icons/code.svg')
    button.menubar__button(@click="editor.chain().focus().setHorizontalRule().run()")
      .icon
        img(src='../../../assets/tiptap/images/icons/hr.svg')
    button.menubar__button(@click="editor.chain().focus().undo().run()" :disabled="!editor.can().undo()")
      .icon
        img(src='../../../assets/tiptap/images/icons/undo.svg')
    button.menubar__button(@click="editor.chain().focus().redo().run()" :disabled="!editor.can().redo()")
      .icon
        img(src='../../../assets/tiptap/images/icons/redo.svg')

    v-dialog(v-model="imageDialog" max-width='540')
      template(v-slot:activator='{ on, attrs }')
        button.menubar__button(:class="options.supportImage ? '' : 'is-disabled'" v-bind='attrs' v-on='options.supportImage ? on : null')
          .icon
            img(src='../../../assets/tiptap/images/icons/image.svg')
      v-card.pa-1
        v-tabs(v-model="imageTab" grow text)
          v-tab(href='#imageTab-upload') Image upload
        v-tabs-items(v-model="imageTab")
          v-tab-item(key='1' value='imageTab-upload')
            v-card-text.mt-5
              v-file-input(v-model="selectedFile" accept="image/*" prepend-icon="mdi-folder-open-outline" show-size placeholder="Select a file" @change="onFileChange")
            v-card-actions
              v-spacer
              v-btn(dark @click='insertImage') Insert image
  editor-content.editor__content(:editor='editor')
  .character-count(v-if="editor")
    p {{ editor.getCharacterCount() }}/{{ limit }} characters
</template>

<script>
import { mapGetters } from 'vuex';
import { Editor, EditorContent } from '@tiptap/vue-2';
import TextAlign from '@tiptap/extension-text-align';
import Highlight from '@tiptap/extension-highlight';
import Underline from '@tiptap/extension-underline';
import Image from '@tiptap/extension-image';
import StarterKit from '@tiptap/starter-kit';
import CharacterCount from '@tiptap/extension-character-count';
import TextStyle from '@tiptap/extension-text-style';
import { Color } from '@tiptap/extension-color';
export default {
  components: {
    EditorContent,
  },
  props: {
    options: {
      content: String,
      editable: Boolean,
      supportImage: Boolean,
    },
  },
  computed: {
    ...mapGetters(['userAccToken', 'lan']),
  },
  data() {
    return {
      limit: 2500,
      editor: null,
      imageDialog: false,
      imageTab: null,
      fileURL: null,
      selectedFile: null,
      isActive: false,
      fileObj: {},
      newsContent: '',
      param: this.$route.params.id,
      nation: '',
    };
  },
  methods: {
    showImagePrompt(command) {
      const src = prompt('Enter the url of your image here');
      if (src !== null) {
        command({ src });
      }
    },
    shouldDisableButton: function (isActive) {
      return !isActive & window.getSelection().isCollapsed;
    },
    addLinkDialog: async function (command) {
      if (window.getSelection().isCollapsed) {
        return;
      }
      let res = await window.prompt('Add link', 'https://');
      if (res && res != 'https://' && res != 'http://') {
        command({ href: res });
      }
    },
    changeLinkDialog: async function (command, attr) {
      let res = await window.prompt('Change link', attr.href);
      if (res != undefined) {
        if (res == 'http://' || res == 'https://') {
          res = '';
        }
        command({ href: res });
      }
    },
    insertHTML: function ({ state, view }, value) {
      const { selection } = state;
      const element = document.createElement('div');
      element.innerHTML = value.trim();
      const slice = DOMParser.fromSchema(state.schema).parseSlice(element);
      const transaction = state.tr.insert(selection.anchor, slice.content);
      view.dispatch(transaction);
    },
    insertImage() {
      if (this.selectedFile) {
        this.uploadFile(this.selectedFile);
      }
      this.imageDialog = false;
      this.selectedFile = null;
    },
    onFileChange() {},
    uploadFile(file) {
      const formData = new FormData();
      formData.append('files', file);
      let blobURL = window.URL.createObjectURL(file);
      if (blobURL) {
        this.editor
          .chain()
          .focus()
          .setImage({ src: blobURL, title: file.name })
          .run();
      }

      this.fileObj[file.name] = file;
    },
    async getData() {
      if (this.$route.query.nation == undefined) {
        this.nation = this.lan;
      } else {
        this.nation = this.$route.query.nation;
      }
      await this.$_admin_get('admin/news/detail/edit', {
        id: this.param,
        nation: this.nation,
      }).then(res => {
        let data = res.data.res[0];
        this.newsContent = data.content;
      });
    },
  },
  async mounted() {
    let content;
    if (this.$route.name == 'news-edit-admin') {
      await this.getData();
      content = this.newsContent;
    } else {
      content = this.options.content;
    }
    this.editor = new Editor({
      editable: this.options.editable,
      content: content,
      autofocus: true,
      extensions: [
        CharacterCount.configure({
          limit: this.limit,
        }),
        StarterKit,
        Underline,
        Image,
        TextStyle,
        Color.configure({
          types: ['textStyle'],
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        Highlight,
      ],
      onUpdate: ({ editor }) => {
        this.options.content = editor.getHTML();
      },
    });
    // 기본 글자 색상 지정
    this.editor.commands.setColor('#000000');
  },

  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>
<style scoped>
input[type='color'] {
  width: 20px;
  height: 24px;
}
.editor__content {
  height: 380px;
  border-radius: 5px;
  background-color: #f5f5f542;
  border: 1px solid #e8e8e8;
  overflow: auto;
}
.menubar__button {
  align-items: center;
}
.editor {
  width: 100%;
  margin: 0;
}
.icon img {
  width: 14.39px;
}
</style>
<style lang="scss">
@import '../../../assets/tiptap/sass/main';
@import '../../../assets/tiptap/sass/editor';
.page {
  &__content {
    padding: 4rem 1rem;
  }

  &__footer {
    text-align: center;
    margin-bottom: 2rem;
  }

  &__source-link {
    display: inline-block;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 0.8rem;
    background-color: rgba($color-black, 0.1);
    color: $color-black;
    border-radius: 5px;
    padding: 0.2rem 0.5rem;
  }
}
.editor .editor__content .ProseMirror ul {
  list-style: decimal;
  display: list-item;
  padding-left: 0;
}
.editor .editor__content .ProseMirror ol {
  list-style: disc;
  display: list-item;
  padding-left: 0;
}
.ProseMirror hr {
  display: block;
  border: none;
  border-top: 2px solid rgba(13, 13, 13, 0.1);
  margin: 2rem 0;
}
.ProseMirror em {
  font-style: italic;
}
</style>
